<script>
  import { onMount } from "svelte";
  export let date;

  onMount(async () => {
    const res = await fetch("/api/date");
    const newDate = await res.text();
    date = newDate;
  });
</script>

<main>
  <h1>Bear Creek Trails</h1>
  <br />
  <h2>coming soon...</h2>
  <p>{date ? date : '...'}</p>
</main>
